import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as value from '../value'

@ngCore.Component({
  imports: [value.Component],
  selector: 'atn-display-variable',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link ents.core.display.Field} */
  public readonly variableSg =
    ngCore.input.required<ents.core.dms.data.query.Variable>({
      alias: 'variable',
    })

  /** @see {@link ents.core.display.Field} */
  public readonly valueSg = ngCore.input.required<ents.core.dms.data.Value>({
    alias: 'value',
  })
  /** TODO:  */
  public readonly typeSg = ngCore.computed(
    (variable = this.variableSg()) => variable.type,
  )
  /** TODO:  */
  public readonly labelSg = ngCore.computed(
    (variable = this.variableSg()) => variable.name,
  )

  /**
   * Determines if input should be required.
   *
   * Input is considered required if variable has a default value.
   */
  public readonly requiredSg = ngCore.computed(
    (variable = this.variableSg()) => variable.defaultValue !== undefined,
  )

  public readonly valueChange =
    ngCore.output<ents.core.display.Field['value']>()
}
